// Flow types automatically removed

import styles from './styles/InteriorsLandingViewAllButton.module.css';
export function InteriorsLandingViewAllButton({ children }) {
    return (
        <div className={styles.viewAllWrapper}>
            <div className={styles.viewAllCta}>{children}</div>
        </div>
    );
}
